// Helfer fuer strukturierte Daten (schema.org / JSON-LD).
// Werden ueber die Seo-Komponente in den <head> gerendert.

const SITE = 'https://sportyreplay.de';

export const absoluteUrl = (u: string) => (u?.startsWith('http') ? u : SITE + u);

/**
 * BreadcrumbList fuer die Pfad-Anzeige in den Google-Suchergebnissen.
 * @param trail Stationen von der Startseite bis zur aktuellen Seite.
 */
export const breadcrumbJsonLd = (trail: { name: string; path: string }[]) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: trail.map((item, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: item.name,
    item: absoluteUrl(item.path),
  })),
});

/**
 * ItemList fuer Uebersichtsseiten (Kategorie, Verein).
 * Listet nur die URLs - die Produktdetails stehen auf der jeweiligen Produktseite.
 */
export const itemListJsonLd = (
  name: string,
  products: { id: number; title: string }[]
) => ({
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  name,
  numberOfItems: products.length,
  itemListElement: products.slice(0, 50).map((p, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: p.title,
    url: `${SITE}/products/${p.id}`,
  })),
});
